import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Zap, Brain, Shield, Flame } from 'lucide-react';
export function SolutionSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8
      }
    }
  };
  return <section className="w-full py-24 px-6 bg-[#0D0D0D]" data-id="element-195">
      <div className="max-w-5xl w-full mx-auto space-y-16" data-id="element-196">
        {/* Header */}
        <div className="text-center space-y-6 max-w-3xl mx-auto" data-id="element-197">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-198">
            La Solución
          </motion.span>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-4xl md:text-6xl font-serif text-[#F5F0E8]" data-id="element-199">
            REINICIO TOTAL 35+
          </motion.h2>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-4" data-id="element-200">
            <p className="text-lg md:text-xl text-[#F5F0E8] font-light" data-id="element-201">
              Presentamos el protocolo diseñado para la mujer que no tiene
              tiempo de irse al Tíbet a meditar.
            </p>
            <p className="text-lg text-[#A89F91]" data-id="element-202">
              REINICIO TOTAL 35+ es un eBook interactivo basado en el Efecto de
              Micro-Retos.
            </p>
          </motion.div>
        </div>

        {/* Subheading */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center text-[#D4A853] text-sm tracking-widest uppercase font-medium max-w-2xl mx-auto border-b border-[#D4A853]/20 pb-2 inline-block w-full" data-id="element-203">
          Esto es lo que vas a lograr en 4 semanas:
        </motion.p>

        {/* Cards Grid - 4 Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-204">
          {/* Card 1 - Energy */}
          <motion.div variants={itemVariants} className="bg-[#1A1A1A] p-8 border-l-4 border-[#D4A853] shadow-2xl hover:bg-[#222] transition-colors duration-300 h-full" data-id="element-205">
            <div className="flex justify-between items-start mb-6" data-id="element-206">
              <Zap className="w-8 h-8 text-[#D4A853]" data-id="element-207" />
              <span className="text-[#D4A853] text-xs font-bold tracking-widest border border-[#D4A853]/30 px-2 py-1 rounded" data-id="element-208">
                SEMANA 1
              </span>
            </div>
            <h3 className="text-2xl font-serif text-[#F5F0E8] mb-3" data-id="element-209">Energía</h3>
            <p className="text-[#A89F91] text-base leading-relaxed" data-id="element-210">
              Hackearemos tu fatiga biológica con cambios minúsculos. Empezarás
              a despertar con el cerebro «encendido».
            </p>
          </motion.div>

          {/* Card 2 - Clarity */}
          <motion.div variants={itemVariants} className="bg-[#1A1A1A] p-8 border-l-4 border-[#D4A853] shadow-2xl hover:bg-[#222] transition-colors duration-300 h-full" data-id="element-211">
            <div className="flex justify-between items-start mb-6" data-id="element-212">
              <Brain className="w-8 h-8 text-[#D4A853]" data-id="element-213" />
              <span className="text-[#D4A853] text-xs font-bold tracking-widest border border-[#D4A853]/30 px-2 py-1 rounded" data-id="element-214">
                SEMANA 2
              </span>
            </div>
            <h3 className="text-2xl font-serif text-[#F5F0E8] mb-3" data-id="element-215">
              Claridad
            </h3>
            <p className="text-[#A89F91] text-base leading-relaxed" data-id="element-216">
              Entrenaremos tu músculo de decisión. Resolverás esas 3 decisiones
              postergadas sin culpa.
            </p>
          </motion.div>

          {/* Card 3 - Control */}
          <motion.div variants={itemVariants} className="bg-[#1A1A1A] p-8 border-l-4 border-[#D4A853] shadow-2xl hover:bg-[#222] transition-colors duration-300 h-full" data-id="element-217">
            <div className="flex justify-between items-start mb-6" data-id="element-218">
              <Shield className="w-8 h-8 text-[#D4A853]" data-id="element-219" />
              <span className="text-[#D4A853] text-xs font-bold tracking-widest border border-[#D4A853]/30 px-2 py-1 rounded" data-id="element-220">
                SEMANA 3
              </span>
            </div>
            <h3 className="text-2xl font-serif text-[#F5F0E8] mb-3" data-id="element-221">Control</h3>
            <p className="text-[#A89F91] text-base leading-relaxed" data-id="element-222">
              Aprenderás a poner límites de acero y recuperarás 1 hora de tu
              vida cada día.
            </p>
          </motion.div>

          {/* Card 4 - Identity */}
          <motion.div variants={itemVariants} className="bg-[#1A1A1A] p-8 border-l-4 border-[#D4A853] shadow-2xl hover:bg-[#222] transition-colors duration-300 h-full" data-id="element-223">
            <div className="flex justify-between items-start mb-6" data-id="element-224">
              <Flame className="w-8 h-8 text-[#D4A853]" data-id="element-225" />
              <span className="text-[#D4A853] text-xs font-bold tracking-widest border border-[#D4A853]/30 px-2 py-1 rounded" data-id="element-226">
                SEMANA 4
              </span>
            </div>
            <h3 className="text-2xl font-serif text-[#F5F0E8] mb-3" data-id="element-227">
              Identidad
            </h3>
            <p className="text-[#A89F91] text-base leading-relaxed" data-id="element-228">
              Apagarás el motor del deber y encenderás el del propósito.
              Volverás a ser la protagonista de tu historia.
            </p>
          </motion.div>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center pt-4" data-id="element-229">
          <motion.a href="#oferta" whileHover={{
          scale: 1.02,
          color: '#E8BE6A'
        }} whileTap={{
          scale: 0.98
        }} className="inline-block text-[#D4A853] font-medium text-sm uppercase tracking-widest border-b border-[#D4A853]/40 pb-1 cursor-pointer transition-colors" data-id="element-230">
            Ver oferta especial ↓
          </motion.a>
        </motion.div>
      </div>
    </section>;
}